<template>
    <div>
        <nav-bar :links="shelf.links"
                 :meta="shelf.meta"
                 :downloadStatus="downloadStatus">
        </nav-bar>
        <b-table :items="shelf.books"
                 :fields="fields"
                 @row-clicked="rowClicked"
                 striped
                 hover
                 small>
        </b-table>
        <nav-bar :links="shelf.links"
                 :meta="shelf.meta"
                 :downloadStatus="downloadStatus">
        </nav-bar>
    </div>
</template>

<script>
    import NavBar from './NavBar.vue'
    import {
        eventBus
    } from '../main';

    export default {
        props: [
            'searchQuery',
            'downloadStatus',
            'shelf',
        ],
        data: function() {
            return {
                fields: {
                    'authors': {
                        label: 'Authors',
                        formatter: 'authorsCommaSpace',
                        tdClass: 'btitle w-25'
                    },
                    'title': {
                        label: 'Title',
                        formatter: 'wrapTitle',
                        tdClass: 'font-italic'
                    },
                    'pubdate': {
                        label: 'Year',
                        formatter: 'publishedYear',
                    },
                    'formats': {
                        label: 'File',
                        formatter: 'getFormats',
                        tdClass: 'formats-download'
                    }

                },
                links: {
                    'next': false,
                    'prev': false
                },
                meta: {},
                book: {},
            }
        },
        methods: {
            readableBytes(bytes) {
                var i = Math.floor(Math.log(bytes) / Math.log(1024)),
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + sizes[i];
            },
            authorsCommaSpace(key, value, book) {
                if (key.length > 3) {
                    key = key.slice(0, 3)
                    key.push("et al.")
                }
                let inner = key.join(',<br/>')
                return `<div title="catalogud by ${book['librarian']}">${inner}</div>`
            },
            publishedYear(key, value, book) {
                let inner = `${key}`.slice(0, 4) + '&nbsp;'
                return `<div title="catalogud by ${book['librarian']}">${inner}</div>`
            },
            getFormats(key, value, book) {
                let f = '';
                for (let frm of book['formats']) {
                    let book_url = book.library_url + frm.dir_path + frm.file_name
                    let size = this.readableBytes(frm.size)
                    let download_stripe = `<a title="${size}" class="motw_table_link" href="${book_url}">.${frm.format }</a>, `;
                    f += download_stripe;
                }
                return f.slice(0, -3)
            },
            rowClicked(item, row, event) {
                this.$store.state.showModal = true;
                this.$store.state.singleBook = false;
                this.$router.push('/book/' + item['_id'])
            },
            wrapTitle(key, value, book) {
                return `<div title="catalogued by ${book['librarian']}">${key}</div>`
            }
        },
        components: {
            NavBar
        }
    }
</script>

<style scoped>
    .table:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/LibraryTable.vue